// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_ji-0";
export var fulfillmentPanelBody = "_ji-1";